import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import Images from "assets/images"
import { EDIT, VIEW } from "const"
import { projectsRoute, projectUsersRoute } from "client/parts/routes"
import { hasAccess, hasProjectAccess } from "client/utils"
import {
    PRM_PROJECT,
    PRM_TEAM,
    StoreType,
    addModal,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    PageForm,
    Logo,
    FormGroup,
    Label,
    LabelButton,
    DateFormatter,
    Delimiter,
    UserIcon,
    Input,
    CKEditor,
    Button,
} from "client/components"

const Details = () => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const projectUserList = useSelector((state: StoreType) => state.projectUser.projectUserList)
    const userList = useSelector((state: StoreType) => state.user.userList)

    const userSettings = useSelector((state: StoreType) => state.system.userSettings)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const defaultLogo = userSettings.project && userSettings.project.defaultLogo
    const editUrl = `${projectsRoute}/${EDIT}/${project.id}`
    const usersUrl = `${projectsRoute}/${VIEW}/${project.id}${projectUsersRoute}`

    const editAccess = hasAccess(PRM_PROJECT, EDIT)
    const allowedToEdit = editAccess || project.owner === userData.userId

    const teamEditAccess = hasProjectAccess(PRM_TEAM, EDIT)

    return (
        <Container>
            <PageHeader>
                <PageTitle>{lang.details}</PageTitle>
            </PageHeader>
            <PageContent>
                <PageForm>
                    <Row>
                        <Col xs={12} md={3}>
                            <Logo
                                logo={project.logo || defaultLogo || Images.noImage}
                                offsetBottom
                            />

                            <FormGroup>
                                <Label>{lang.created}</Label>
                                <DateFormatter date={project.createdAt} />
                            </FormGroup>
                            <Delimiter size="sm" />

                            <FormGroup>
                                <Label>{lang.modified}</Label>
                                <DateFormatter date={project.updatedAt} />
                            </FormGroup>
                            <Delimiter size="sm" />

                            <FormGroup>
                                <Label>{lang.owner}</Label>
                                <UserIcon user={userList[project.owner]} size="sm" />
                            </FormGroup>
                            <Delimiter size="sm" />

                            <FormGroup>
                                <Label>
                                    {lang.participants}
                                    {
                                        teamEditAccess
                                        && (
                                            <LabelButton onClick={() => dispatch(addModal({ url: usersUrl }))}>
                                                {lang.manage}
                                            </LabelButton>
                                        )
                                    }
                                </Label>
                                {
                                    projectUserList
                                    && projectUserList[project.id]
                                    && projectUserList[project.id].map((userId) => (
                                        <UserIcon
                                            key={userId}
                                            user={userList[userId]}
                                            size="sm"
                                        />
                                    ))
                                }
                            </FormGroup>
                        </Col>
                        <Col xs={12} md={9}>
                            <Row>
                                <Col xs={12} md={4}>
                                    <FormGroup>
                                        <Label>{lang.publicId}</Label>
                                        <Input type="text" value={project.publicId} readOnly />
                                    </FormGroup>
                                </Col>
                                <Col xs={12} md={8}>
                                    <FormGroup>
                                        <Label>{lang.name}</Label>
                                        <Input type="text" value={project.name} readOnly />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12}>
                                    <FormGroup>
                                        <Label>{lang.documentId}</Label>
                                        <Input type="text" value={project.documentId} readOnly />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>{lang.description}</Label>
                                        <CKEditor
                                            data={project.description}
                                            isReadOnly
                                        />
                                    </FormGroup>
                                </Col>
                                {
                                    allowedToEdit && (
                                        <Col xs={12}>
                                            <Button onClick={() => dispatch(addModal({ url: editUrl }))}>
                                                {lang.edit}
                                            </Button>
                                        </Col>
                                    )
                                }
                            </Row>
                        </Col>
                    </Row>
                </PageForm>
            </PageContent>
        </Container>
    )
}
export default Details
